import { IconDownload, IconEdit, IconPlus, IconReload, IconSearch, IconTrash, IconUpload } from "@tabler/icons-react";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import type { MenuItem } from "primereact/menuitem";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { RAILWAY_ZONES, STATION_METADATA_DATA } from "../constants/data.cnst";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import Table from "../components/table";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { STATION_METADATA } from "../interfaces/dashboard";

export default function StationMetadata() {

    const breadcrumb: MenuItem[] = [
        { label: 'Station Metadata', style: { pointerEvents: 'none' }, className: 'font-semibold text-gray-900' }
    ];
        const stationTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.STATIONS_LIST;
    const toast = useRef<Toast>(null);

    const stationStats = [
        { label: "Total Stations", value: '-', color: "#53D28C", key: "totalStations" },
        { label: "Active Stations", value: '-', color: "#FFB269", key: "activeStations" },
        { label: "Inactive Stations", value: '-', color: "#EA5455", key: "inactiveStations" }
    ]

    const [filters, setFilters] = useState({
        station: "",
        zone: "All Zones",
        status: "All Status",
        //   date: [pastMonth, today] as (Date | null)[]
    });

    const [firstStation, setFirstStation] = useState(0);
    const [rowsStation, setRowsStation] = useState(10);

    const statusList: { label: string; value: string }[] = [
        { label: 'All Status', value: 'totalStatus' },
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' }
    ]

    const zonesList: { label: string; value: string }[] = [{ label: 'All Zones', value: 'totalZones' }, ...RAILWAY_ZONES.map(zone => ({ label: zone.zoneName, value: zone.zoneName }))]

    const stationList: { label: string; value: string }[] = [];

    //     const { data: stationCountsData, isFetching: isStationDataLoading } = useQuery({
    //     queryKey: ["trips-count", tripsSummaryQueryParams],
    //     queryFn: () =>
    //       fetchApi({
    //         endpoint: APIMapping.TRIPS_COUNTS,
    //         queryParams: tripsSummaryQueryParams,
    //         resourceName: HBL_PA_RESOURCES.EVENTS
    //       }),
    //     enabled: !!tripsSummaryQueryParams
    //   });

    //     const stationStatistics = useMemo(() => {
    //       if (!stationCountsData?.result) return stationStats;

    //       return stationStats.map(stat => ({
    //         ...stat,
    //         value: stationCountsData?.response?.[stat.key] ?? '-',
    //         abortedTrips: stationCountsData?.response?.abortedTrips ?? '-',
    //         completedTrips: stationCountsData?.response?.completedTrips ?? '-',
    //         openTrips: stationCountsData?.response?.openTrips ?? '-',
    //       }));
    //     }, [stationCountsData]);

      const stationTableData: STATION_METADATA[] = STATION_METADATA_DATA;
    //   eventsApiResponse?.response?.data?.map((rowData: EVENT_TABLE) => {
    //         return {
    //             ...rowData,
    //             eventCategory: rowData.eventCategory.replace('_', ' '),
    //             eventId: rowData.eventId,
    //             absoluteLocation: rowData.absoluteLocation || 'NA',
    //             displayEventId: rowData.eventId.substring(0, 5) + '...'
    //         };
    //     }) ?? [];

        const header = (

        <div className="flex justify-between items-center">
            <h3 className="m-0 font-semibold">Stations List</h3>

            <Button
                label="Download"
                icon={<IconDownload size={20} />}
                // loading={isDownloading}
                // disabled={isDownloading || displayTableData.length === 0}
                className="bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500 "
                // onClick={() => shouldFetchReports && handleDownload()}
            />
        </div>

    );

    return (

        <div className="h-[calc(100vh-4rem)] p-6 flex-1 overflow-y-auto">

            <Toast ref={toast} />
            <div className="flex align-items items-center gap-1 justify-between">

                <BreadCrumb model={breadcrumb} />
                <div className="flex gap-2 ">
                    <Button
                        label="Upload Station"
                        outlined
                        icon={<IconUpload size={20} />}
                        className="ml-auto mb-2 bg-gray-200 border-gray-200 text-gray-700 dark:bg-gray-800 dark:border-gray-800 dark:text-gray-200"
                    />

                    <Button
                        label="Add Station"
                        icon={<IconPlus size={20} />}
                        className="ml-auto mb-2 bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500"
                    />
                </div>

            </div>


            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-6 mt-2">

                {stationStats.map((event, index) => (
                    <div className="md:col-span-4" key={event.label}>
                        <Card className="h-full" key={index}>
                            <div className={`pl-5 relative ${index === 0 ? "station-metadata-tooltip cursor-pointer" : ""
                                }`}>
                                <span
                                    className="absolute left-0 top-0 w-[.25rem] rounded-full h-full"
                                    style={{ backgroundColor: event.color }}
                                ></span>
                                {/* {isTripSummaryStatisticsLoading ? (
                                    <>
                                        <Skeleton width="60%" height="1.5rem" className="mb-2" />
                                        <Skeleton width="40%" height="1.5rem" />
                                    </>
                                ) : ( */}
                                <>
                                    <p className="text-gray-700 dark:text-gray-100">{event.label}</p>
                                    <h2 className="text-3xl text-gray-900 dark:text-gray-100 font-bold">
                                        {event.value}
                                    </h2>
                                </>
                                {/* )} */}
                            </div>
                        </Card>
                    </div>
                ))}

                {/* Filters */}
                <div className="md:col-span-12">
                    <Card>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            {/* Search */}
                            <div>
                                <label className="block mb-2 text-sm font-medium">
                                    Search
                                </label>
                                <Dropdown
                                    value={filters.station}
                                    onChange={(e) =>
                                        setFilters((prev) => ({
                                            ...prev,
                                            station: e.target.value,
                                        }))
                                    }
                                    options={stationList}
                                    optionLabel="label"
                                    placeholder="Search Station ID, Station Name"
                                    filter
                                    filterDelay={400}
                                    className="w-full"
                                />
                            </div>

                            {/* Zone */}
                            <div>
                                <label className="block mb-2 text-sm font-medium">
                                    Zone
                                </label>
                                <Dropdown
                                    value={filters.zone}
                                    onChange={(e) =>
                                        setFilters((prev) => ({
                                            ...prev,
                                            zone: e.target.value,
                                        }))
                                    }
                                    options={zonesList}
                                    optionLabel="label"
                                    placeholder="All Zones"
                                    className="w-full"
                                />
                            </div>

                            {/* Status */}
                            <div>
                                <label className="block mb-2 text-sm font-medium">
                                    Status
                                </label>
                                <Dropdown
                                    value={filters.status}
                                    onChange={(e) =>
                                        setFilters((prev) => ({
                                            ...prev,
                                            status: e.target.value,
                                        }))
                                    }
                                    options={statusList}
                                    optionLabel="label"
                                    placeholder="All Status"
                                    className="w-full"
                                />
                            </div>
                        </div>

                        {/* Buttons Row */}
                        <div className="flex justify-end gap-3 mt-6">
                            <Button
                                label="Search"
                                icon={<IconSearch size={18} />}
                                className="mb-2 bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500"
                            />

                            <Button
                                label="Reset"
                                icon={<IconReload size={18} />}
                                outlined
                                className="mb-2 bg-gray-200 border-gray-200 text-gray-700 dark:bg-gray-800 dark:border-gray-800 dark:text-gray-200"
                            // onClick={handleReset}
                            />
                        </div>
                    </Card>
                </div>

                {/*Station Table*/}
                <div className="md:col-span-12">
                                    <Card header={header} className="p-card-body-p-0 h-full">
                                        <Table
                                            columns={stationTableColumns}
                                            data={stationTableData}
                                            showGridlines={true}
                                            paginator={true}
                                            // isLoading={isEventApiFetching}
                                            first={firstStation}
                                            rows={rowsStation}
                                            // totalRecords={totalEvents}
                                            renderCell={(rowData, field) => {
                                                if (field === 'actions') {
                                                    return (
                                                        <div className="flex gap-1">
                                                            <Button
                                                            label={rowData['actions']}
                                                                icon={<IconEdit size={18} />}
                                                                className="p-button-rounded p-button-info"
                                                                // onClick={() => handleViewDetails(rowData)}
                                                            />
                                                            <Button
                                                                icon={<IconTrash size={18} />}
                                                                className="p-button p-button-danger"
                                                                // onClick={() => handleResetEvent(rowData)}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }}
                                            onPageChangeExternal={(page_num, total_entry_per_page) => {
                                                setFirstStation((page_num - 1) * total_entry_per_page);
                                                setRowsStation(total_entry_per_page);
                                                // setEventsQueryParams((prev: any) => ({
                                                //     ...prev,
                                                //     page_num: page_num,
                                                //     total_entry_per_page: total_entry_per_page
                                                // }));
                                            }}
                                        />
                                    </Card>
                                </div>
            </div>
        </div>
    )

}